import { render } from "./Students.vue?vue&type=template&id=370dd3a2&ts=true"
import script from "./Students.vue?vue&type=script&lang=ts"
export * from "./Students.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__